import React from 'react';
import { bool } from 'prop-types';

// Helpers
import { copy } from '../../constants';
// Styles
import styles from './styles/Recommendations.scss';

const NoPermission = ({ portfolioDoesNotExist }) => {
    const headerCopy = portfolioDoesNotExist
        ? copy.noPermission.DELETED_FOLDER_HEADER
        : copy.noPermission.PRIVATE_FOLDER_HEADER;

    return (
        <div className={styles.noPermission}>
            <div className={styles.private} data-tn="recommendations-no-permission">
                {headerCopy}
            </div>
            {portfolioDoesNotExist ? null : (
                <div className={styles.access}>{copy.noPermission.PRIVATE_FOLDER_PAGE_ACCESS}</div>
            )}
        </div>
    );
};

NoPermission.propTypes = {
    portfolioDoesNotExist: bool,
};

export default NoPermission;
